import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class ProjectSourcesService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get project source
     * @returns ProjectSource OK.
     * @throws ApiError
     */
    getProjectSource({ orgId, projectId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/source', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update project source
     * @returns Project OK.
     * @throws ApiError
     */
    changeProjectSource({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/source', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get clone url
     * @returns GetProjectCloneUrl Clone URL for project repository.
     * @throws ApiError
     */
    getProjectGitCloneUrl({ orgId, projectId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/clone-url', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Download project
     * @returns binary ZIP file with project source.
     * @throws ApiError
     */
    downloadProjectSource({ orgId, projectId, branchName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/download', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'branchName': branchName,
            }, errors: {
                302: `Found.`,
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of project source commits
     * @returns ProjectSourceCommitList OK.
     * @throws ApiError
     */
    listProjectCommits({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/source-commits', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get single project source commit
     * @returns ProjectSourceCommit OK.
     * @throws ApiError
     */
    getProjectCommit({ orgId, projectId, commitId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/source-commits/{commitId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'commitId': commitId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=ProjectSourcesService.js.map